var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var issueFormatter = function () {
    return [];
};
if (process.env.NODE_ENV !== 'production') {
    var issueValue_1 = '%o';
    issueFormatter = function (message, object, highlight, replacer, transform) {
        if (highlight === void 0) { highlight = {}; }
        if (replacer === void 0) { replacer = null; }
        var issueArgs = [];
        var issueObject = {};
        for (var key in object) {
            var isIssue = key in highlight;
            issueObject[isIssue ? "%c".concat(key, "%c") : key] = isIssue ? issueValue_1 : object[key];
            if (isIssue) {
                issueArgs.push('font-weight: bold; text-decoration: underline', 'font-weight: normal; text-decoration: none', object[key]);
            }
        }
        if (transform) {
            issueObject = transform(issueObject);
        }
        var block = JSON.stringify(issueObject, replacer, 2);
        for (var key in highlight) {
            block = block.replace("  \"%c".concat(key, "%c\": \"").concat(issueValue_1, "\""), "  %c\"".concat(key, "\"%c: ").concat(issueValue_1));
        }
        return __spreadArray(["".concat(message, "\n\n").concat(block)], issueArgs, true);
    };
}

function formatRule(selector, block) {
    return "".concat(selector, "{").concat(block, "}");
}
function formatClassRule(className, block, selector) {
    if (selector === void 0) { selector = ''; }
    return ".".concat(formatRule(className + selector, block));
}
function formatSupportsRule(condition, block) {
    return "@supports ".concat(typeof block === 'string' ? formatRule(condition, block) : condition);
}
function formatKeyframesRule(name, blockList) {
    return "@keyframes ".concat(formatRule(name, blockList));
}
function formatFontFaceRule(block) {
    return formatRule('@font-face', block);
}
function formatMediaRule(query, block) {
    return "@media ".concat(typeof block === 'string' ? formatRule(query, block) : query);
}
function combineConditions(a, b) {
    return "".concat(a[0] === '(' ? a : "(".concat(a, ")"), " and ").concat(b[0] === '(' ? b : "(".concat(b, ")"));
}
var PRETTY_REGEX = /[{:;}]|(?:(["']).*?\1)/g;
function prettifyRule(rule) {
    return rule.replace(PRETTY_REGEX, function (match) {
        return match === '{' ? ' {\n  ' : match === ':' ? ': ' : match === ';' ? ';\n  ' : match === '}' ? ';\n}' : match;
    });
}

function parseDeclarationBlock(declarations) {
    var block = '';
    var property;
    for (property in declarations) {
        var value = declarations[property];
        if (typeof value === 'object') {
            for (var _i = 0, value_1 = value; _i < value_1.length; _i++) {
                var fallback = value_1[_i];
                if (block) {
                    block += ';';
                }
                block += parseDeclaration(property, fallback);
            }
        }
        else {
            if (block) {
                block += ';';
            }
            block += parseDeclaration(property, value);
        }
    }
    return block;
}
function parseDeclaration(property, value) {
    return "".concat(hyphenateProperty(property), ":").concat(value);
}
var hyphenateRegex = /(?:^(ms|moz|webkit))|[A-Z]/g;
var propertyCache = {};
function hyphenateProperty(property) {
    return property in propertyCache
        ? propertyCache[property]
        : (propertyCache[property] = property.replace(hyphenateRegex, '-$&').toLowerCase());
}

var ANIMATION_NAME = 'animationName';
var FONT_FAMILY = 'fontFamily';
var Injector =  (function () {
    function Injector(className, keyframes, fontFace, globals) {
        this.injectClassName = function (declarations, selector, condition) {
            return className(parseDeclarationBlock(declarations), selector, condition);
        };
        this.injectKeyframes = function (declarationList) {
            var blockList = '';
            for (var identifier in declarationList) {
                blockList += formatRule(identifier, parseDeclarationBlock(declarationList[identifier]));
            }
            return keyframes(blockList);
        };
        this.injectFontFace = function (original) {
            if (process.env.NODE_ENV !== 'production') {
                if (!(FONT_FAMILY in original)) {
                    console.error("The CSS property `".concat(FONT_FAMILY, "` in font face must be defined:\n\n"), prettifyRule(parseDeclarationBlock(original)));
                }
            }
            var declarations = {};
            for (var property in original) {
                if (property !== FONT_FAMILY) {
                    declarations[property] = original[property];
                }
            }
            var family = original[FONT_FAMILY];
            declarations[FONT_FAMILY] = family;
            fontFace(parseDeclarationBlock(declarations));
            return family;
        };
        this.injectGlobals = function (declarations, selector) {
            var rule = formatRule(selector, parseDeclarationBlock(declarations));
            globals(rule);
        };
    }
    return Injector;
}());

var GROUPING_IDENTIFIER = '@'.charCodeAt(0);
var MEDIA_IDENTIFIER = 'm'.charCodeAt(0);
var SUPPORTS_IDENTIFIER = 's'.charCodeAt(0);
var PSEUDO_IDENTIFIER = ':'.charCodeAt(0);
var ATTRIBUTE_IDENTIFIER = '['.charCodeAt(0);
function createStyleInjectors(getInjector, transformer) {
    var cache = {};
    var createResolver = function (inject) {
        var resolver = function (style, theme, styleIndex, media, condition, selector) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var _j;
            if (styleIndex === void 0) { styleIndex = {}; }
            var className = '';
            var properties = Object.keys(style);
            for (var i = properties.length; i > 0; i--) {
                var property = properties[i - 1];
                var value = style[property];
                if (typeof value === 'function') {
                    value = value(theme);
                }
                if (value === null) {
                    value = void 0;
                }
                if (process.env.NODE_ENV !== 'production') {
                    var issueTransformer = function (object) {
                        var _a, _b;
                        if (selector) {
                            object = (_a = {}, _a[selector] = object, _a);
                        }
                        if (media) {
                            object = (_b = {}, _b[media] = object, _b);
                        }
                        return object;
                    };
                    if (['undefined', 'string', 'number', 'object'].indexOf(typeof value) === -1) {
                        console.error.apply(console, issueFormatter("Value from property `".concat(property, "` has to be a string, number, plain object or array in:"), style, (_a = {}, _a[property] = value, _a), null, issueTransformer));
                    }
                    if (value === '') {
                        console.error.apply(console, issueFormatter("Value from property `".concat(property, "` is an empty string and may cause some unexpected behavior in:"), style, (_b = {}, _b[property] = value, _b), null, issueTransformer));
                    }
                    if (typeof value === 'number' && Number.isNaN(value)) {
                        console.error.apply(console, issueFormatter("Value from property `".concat(property, "` is a NaN and may cause some unexpected behavior in:"), style, (_c = {}, _c[property] = value, _c), null, issueTransformer));
                    }
                    if (typeof value === 'number' && !Number.isFinite(value)) {
                        console.error.apply(console, issueFormatter("Value from property `".concat(property, "` is an infinite number and may cause some unexpected behavior in:"), style, (_d = {}, _d[property] = value, _d), null, issueTransformer));
                    }
                    if (typeof value === 'object' && Object.keys(value).length === 0) {
                        console.warn.apply(console, issueFormatter("Value from property `".concat(property, "` is an empty object and can be removed in:"), style, (_e = {}, _e[property] = value, _e), null, issueTransformer));
                    }
                }
                if (property === '@keyframes') {
                    property = ANIMATION_NAME;
                }
                if (property === '@font-face') {
                    property = FONT_FAMILY;
                }
                if (property === ANIMATION_NAME ||
                    property === FONT_FAMILY ||
                    typeof value !== 'object' ||
                    Array.isArray(value)) {
                    var declarations = getIndex(styleIndex, media, condition, selector);
                    if (!(property in declarations)) {
                        if (typeof value === 'object') {
                            if (property === ANIMATION_NAME) {
                                var keyframes = [].concat(value);
                                var names = [];
                                for (var j = 0; j < keyframes.length; j++) {
                                    var keyframe = keyframes[j];
                                    if (typeof keyframe === 'object') {
                                        var list = {};
                                        for (var key in keyframe) {
                                            var block = resolveStyle(keyframe[key], theme);
                                            list[key] = transformer ? transformer(block) : block;
                                        }
                                        names[j] = getInjector().injectKeyframes(list);
                                    }
                                }
                                value = names.length === 1 ? names[0] : names;
                            }
                            if (property === FONT_FAMILY) {
                                var fonts = [].concat(value);
                                var names = [];
                                for (var _i = 0, fonts_1 = fonts; _i < fonts_1.length; _i++) {
                                    var font = fonts_1[_i];
                                    if (typeof font === 'object') {
                                        var fontFace = resolveStyle(font, theme);
                                        var name = getInjector().injectFontFace(transformer ? transformer(fontFace) : fontFace);
                                        if (names.indexOf(name) === -1) {
                                            names.push(name);
                                        }
                                    }
                                    else {
                                        names.push(font);
                                    }
                                }
                                value = names.join(',');
                            }
                        }
                        var declaration = {};
                        declarations[property] = declaration[property] = value;
                        if (typeof value !== 'undefined' && inject) {
                            var values = void 0;
                            var key = void 0;
                            if (typeof value === 'string' || typeof value === 'number') {
                                var cacheIndex = getIndex(cache, media, condition, selector);
                                values = ((_j = cacheIndex[property]) !== null && _j !== void 0 ? _j : (cacheIndex[property] = {}));
                                key = value;
                                if (key in values) {
                                    className += ' ' + values[value];
                                    continue;
                                }
                            }
                            var declarationClassName = void 0;
                            className +=
                                ' ' +
                                    (declarationClassName = getInjector(media).injectClassName(transformer ? transformer(declaration) : declaration, selector, condition));
                            if (values && key) {
                                values[key] = declarationClassName;
                            }
                        }
                    }
                    continue;
                }
                var identifier = property.charCodeAt(0);
                var nextMedia = '';
                var nextCondition = '';
                if (identifier === GROUPING_IDENTIFIER) {
                    var nextIdentifier = property.charCodeAt(1);
                    if (nextIdentifier === MEDIA_IDENTIFIER) {
                        nextMedia = property.slice(6).trim();
                    }
                    else if (nextIdentifier === SUPPORTS_IDENTIFIER) {
                        nextCondition = property.slice(9).trim();
                    }
                }
                if (nextMedia || nextCondition || identifier === PSEUDO_IDENTIFIER || identifier === ATTRIBUTE_IDENTIFIER) {
                    var result = resolver(value, theme, styleIndex, nextMedia ? (media ? combineConditions(media, nextMedia) : nextMedia) : media, nextCondition ? (condition ? combineConditions(condition, nextCondition) : nextCondition) : condition, identifier === PSEUDO_IDENTIFIER || identifier === ATTRIBUTE_IDENTIFIER
                        ? (selector !== null && selector !== void 0 ? selector : '') + property
                        : selector);
                    if (inject) {
                        className += result;
                    }
                    continue;
                }
                var extensions = Object.keys(value);
                for (var j = extensions.length; j > 0; j--) {
                    var extension = extensions[j - 1];
                    var longhandValue = value[extension];
                    var alias = false;
                    if (extension === 'y' || extension === 'xy') {
                        alias = true;
                        var result = resolver((_f = {}, _f[property + 'Top'] = longhandValue, _f[property + 'Bottom'] = longhandValue, _f), theme, styleIndex, media, condition, selector);
                        if (inject) {
                            className += result;
                        }
                    }
                    if (extension === 'x' || extension === 'xy') {
                        alias = true;
                        var result = resolver((_g = {}, _g[property + 'Left'] = longhandValue, _g[property + 'Right'] = longhandValue, _g), theme, styleIndex, media, condition, selector);
                        if (inject) {
                            className += result;
                        }
                    }
                    if (!alias) {
                        var result = resolver((_h = {}, _h[property + extension[0].toUpperCase() + extension.slice(1)] = longhandValue, _h), theme, styleIndex, media, condition, selector);
                        if (inject) {
                            className += result;
                        }
                    }
                }
            }
            return inject ? className : styleIndex;
        };
        return resolver;
    };
    var resolveStyle = createResolver(false);
    var injectStyle = createResolver(true);
    function injectGlobals(selector, result, media) {
        var properties = Object.keys(result);
        var declarations = {};
        var hasDeclarations = false;
        for (var i = properties.length - 1; i >= 0; i--) {
            var property = properties[i];
            var identifier = property.charCodeAt(0);
            if (identifier !== GROUPING_IDENTIFIER &&
                identifier !== PSEUDO_IDENTIFIER &&
                identifier !== ATTRIBUTE_IDENTIFIER) {
                declarations[property] = result[property];
                hasDeclarations = true;
            }
        }
        if (hasDeclarations) {
            getInjector(media).injectGlobals(transformer ? transformer(declarations) : declarations, selector);
        }
        for (var i = properties.length - 1; i >= 0; i--) {
            var property = properties[i];
            var identifier = property.charCodeAt(0);
            if (identifier === GROUPING_IDENTIFIER && property.charCodeAt(1) === MEDIA_IDENTIFIER) {
                injectGlobals(selector, result[property], property.slice(7));
            }
            else if (identifier === PSEUDO_IDENTIFIER || identifier === ATTRIBUTE_IDENTIFIER) {
                injectGlobals(selector + property, result[property], media);
            }
        }
    }
    return [
        function (styles, theme) {
            if (theme === void 0) { theme = {}; }
            styles = Array.isArray(styles) ? styles : [styles];
            var index = {};
            var classNames = '';
            for (var i = styles.length - 1; i >= 0; i--) {
                classNames += injectStyle(styles[i], theme, index);
            }
            return classNames.slice(1);
        },
        function (styles, theme) {
            if (theme === void 0) { theme = {}; }
            for (var property in styles) {
                injectGlobals(property, resolveStyle(styles[property], theme));
            }
        },
    ];
}
function getIndex(indexes, media, condition, selector) {
    var _a, _b, _c;
    var index = indexes;
    if (media) {
        index = (_a = index[formatMediaRule(media)]) !== null && _a !== void 0 ? _a : (index[formatMediaRule(media)] = {});
    }
    if (condition) {
        index = (_b = index[formatSupportsRule(condition)]) !== null && _b !== void 0 ? _b : (index[formatSupportsRule(condition)] = {});
    }
    if (selector) {
        return ((_c = index[selector]) !== null && _c !== void 0 ? _c : (index[selector] = {}));
    }
    else {
        return index;
    }
}

var DEFAULT_HYDRATION_IDENTIFIER = 'glitz';

function injectRule(sheet, rule, index) {
    if (index === void 0) { index = sheet.cssRules.length; }
    try {
        sheet.insertRule(rule, index);
    }
    catch (_a) {
        if (process.env.NODE_ENV !== 'production') {
            console.warn("Failed to insert this CSS rule possibly because the selector isn't supported by the browser:\n\n", prettifyRule(rule));
        }
    }
}
function injectSupportsRule(sheet, rule, condition) {
    if (typeof condition === 'undefined') {
        return injectRule(sheet, rule);
    }
    if (typeof CSSSupportsRule !== 'undefined') {
        for (var _i = 0, _a = sheet.cssRules; _i < _a.length; _i++) {
            var cssRule = _a[_i];
            if (cssRule instanceof CSSSupportsRule && cssRule.conditionText === condition) {
                return injectRule(cssRule, rule);
            }
        }
    }
    return injectRule(sheet, formatSupportsRule(condition, rule));
}
function createStyleElement(media, identifier) {
    var element = document.createElement('style');
    if (media) {
        element.media = media;
    }
    element.dataset[identifier] = '';
    return element;
}
function insertStyleElement(element, insertBefore) {
    document.head.insertBefore(element, insertBefore);
    return element;
}
function isCSSStyleSheet(sheet) {
    if (!sheet) {
        return false;
    }
    return 'cssRules' in sheet;
}

function createHashCounter(prefix, count, offset, msb, power) {
    if (prefix === void 0) { prefix = ''; }
    if (count === void 0) { count = 0; }
    if (offset === void 0) { offset = 10; }
    if (msb === void 0) { msb = 35; }
    if (power === void 0) { power = 1; }
    function increment() {
        var virtualCount = count + offset;
        if (virtualCount === msb) {
            offset += (msb + 1) * 9;
            msb = Math.pow(36, ++power) - 1;
        }
        count++;
        if (virtualCount === 373) {
            return increment();
        }
        return prefix + virtualCount.toString(36);
    }
    return Object.assign(increment, {
        clone: function () {
            return createHashCounter(prefix, count, offset, msb, power);
        },
    });
}

function createInjectorIndexes(plainIndex, plainSupportsIndex, selectorIndex, selectorSupportsIndex, keyframesIndex, fontFaceIndex) {
    if (plainIndex === void 0) { plainIndex = {}; }
    if (plainSupportsIndex === void 0) { plainSupportsIndex = {}; }
    if (selectorIndex === void 0) { selectorIndex = {}; }
    if (selectorSupportsIndex === void 0) { selectorSupportsIndex = {}; }
    if (keyframesIndex === void 0) { keyframesIndex = {}; }
    if (fontFaceIndex === void 0) { fontFaceIndex = []; }
    return [
        function (selector, condition) {
            var _a, _b, _c, _d;
            var _e;
            var index = plainIndex;
            if (condition) {
                if (selector) {
                    (_a = selectorSupportsIndex[condition]) !== null && _a !== void 0 ? _a : (selectorSupportsIndex[condition] = {});
                    (_b = (_e = selectorSupportsIndex[condition])[selector]) !== null && _b !== void 0 ? _b : (_e[selector] = {});
                    index = selectorSupportsIndex[condition][selector];
                }
                else {
                    (_c = plainSupportsIndex[condition]) !== null && _c !== void 0 ? _c : (plainSupportsIndex[condition] = {});
                    index = plainSupportsIndex[condition];
                }
            }
            else if (selector) {
                (_d = selectorIndex[selector]) !== null && _d !== void 0 ? _d : (selectorIndex[selector] = {});
                index = selectorIndex[selector];
            }
            return index;
        },
        keyframesIndex,
        fontFaceIndex,
        function () {
            return createInjectorIndexes(clone(plainIndex), clone(plainSupportsIndex), clone(selectorIndex), clone(selectorSupportsIndex), clone(keyframesIndex), fontFaceIndex.slice(0));
        },
        plainIndex,
        plainSupportsIndex,
        selectorIndex,
        selectorSupportsIndex,
    ];
}
function clone(index) {
    var copy = {};
    for (var key in index) {
        var value = index[key];
        if (typeof value === 'string') {
            copy[key] = value;
        }
        else {
            copy[key] = clone(value);
        }
    }
    return copy;
}

var InjectorClient =  (function (_super) {
    __extends(InjectorClient, _super);
    function InjectorClient(element, classNameHash, keyframesHash) {
        var _this = this;
        var _a = createInjectorIndexes(), getIndex = _a[0], keyframesIndex = _a[1], fontFaceIndex = _a[2];
        var globalRuleIndex = 0;
        var sheet = element.sheet;
        if (!isCSSStyleSheet(sheet)) {
            throw new Error('HTMLStyleElement was not inserted properly into DOM');
        }
        _this = _super.call(this, function (block, selector, condition) {
            var index = getIndex(selector, condition);
            if (index[block]) {
                return index[block];
            }
            var className = classNameHash();
            index[block] = className;
            injectSupportsRule(sheet, formatClassRule(className, block, selector), condition);
            return className;
        }, function (blockList) {
            if (keyframesIndex[blockList]) {
                return keyframesIndex[blockList];
            }
            var name = keyframesHash();
            keyframesIndex[blockList] = name;
            injectRule(sheet, formatKeyframesRule(name, blockList));
            return name;
        }, function (block) {
            if (fontFaceIndex.indexOf(block) === -1) {
                fontFaceIndex.push(block);
                injectRule(sheet, formatFontFaceRule(block));
            }
        }, function (rule) {
            injectRule(sheet, rule, globalRuleIndex++);
        }) || this;
        _this.injectRaw = function (rule) {
            injectRule(sheet, rule);
        };
        _this.hydrateClassName = function (body, className, selector, condition) {
            classNameHash();
            var index = getIndex(selector, condition);
            index[body] = className;
        };
        _this.hydrateKeyframes = function (body, name) {
            keyframesHash();
            keyframesIndex[body] = name;
        };
        _this.hydrateFontFace = function (body) {
            fontFaceIndex.push(body);
        };
        return _this;
    }
    return InjectorClient;
}(Injector));

var BLOCK_START_CODE = '{'.charCodeAt(0);
var BLOCK_END_CODE = '}'.charCodeAt(0);
var SINGLE_QUOTE_CODE = "'".charCodeAt(0);
var DOUBLE_QUOTE_CODE = '"'.charCodeAt(0);
var SLASH_CODE = '/'.charCodeAt(0);
var ASTERISK_CODE = '*'.charCodeAt(0);
var PLAIN_SELECTOR = /\.([\w]+)((?::.+)|(\[.+\]))?/;
var KEYFRAMES_SELECTOR = /@keyframes (.+)/;
var MEDIA_SELECTOR = /@media[\s]?(.+)/;
var SUPPORTS_SELECTOR = /@supports[\s]?(.+)/;
function createHydrate(getInjector) {
    function matchDepth(initialDepth, media, condition) {
        if (media) {
            initialDepth++;
        }
        if (condition) {
            initialDepth++;
        }
        return initialDepth;
    }
    return function hydrate(css, forceMedia, callback) {
        var length = css.length;
        var comment = false;
        var string = false;
        var depth = 0;
        var rule = '';
        var media = '';
        var condition = '';
        var selector = '';
        var body = '';
        for (var i = 0; i < length; i++) {
            var character = css[i];
            var code = character.charCodeAt(0);
            var wasComment = false;
            rule += character;
            if (string === false) {
                if (comment === false) {
                    if (code === SLASH_CODE && length > i + 1 && css.charCodeAt(i + 1) === ASTERISK_CODE) {
                        comment = true;
                    }
                    else if (code === SINGLE_QUOTE_CODE || code === DOUBLE_QUOTE_CODE) {
                        string = code;
                    }
                    else if (code === BLOCK_START_CODE) {
                        depth++;
                        if (matchDepth(1, media, condition) === depth) {
                            var match = MEDIA_SELECTOR.exec(selector);
                            if (match) {
                                media = match[1];
                                rule = '';
                                selector = '';
                            }
                            match = SUPPORTS_SELECTOR.exec(selector);
                            if (match) {
                                condition = match[1];
                                rule = '';
                                selector = '';
                            }
                            continue;
                        }
                    }
                    else if (code === BLOCK_END_CODE) {
                        depth--;
                        if (media && condition && depth === 1) {
                            condition = '';
                            continue;
                        }
                        if (condition && depth === 0) {
                            condition = '';
                            continue;
                        }
                        if (media && depth === 0) {
                            media = '';
                            continue;
                        }
                        if (matchDepth(0, media, condition) === depth) {
                            var injector = getInjector(forceMedia || media || void 0);
                            var match = void 0;
                            if ((match = PLAIN_SELECTOR.exec(selector))) {
                                injector.hydrateClassName(body, match[1], match[2], condition || void 0);
                            }
                            else if ((match = KEYFRAMES_SELECTOR.exec(selector))) {
                                injector.hydrateKeyframes(body, match[1]);
                            }
                            else if (selector === '@font-face') {
                                injector.hydrateFontFace(body);
                            }
                            if (callback) {
                                callback(injector, rule);
                            }
                            rule = '';
                            selector = '';
                            body = '';
                            continue;
                        }
                    }
                }
                else if (code === SLASH_CODE && css.charCodeAt(i - 1) === ASTERISK_CODE) {
                    comment = false;
                    wasComment = true;
                }
            }
            else if (code === string) {
                string = false;
            }
            if (matchDepth(0, media, condition) < depth) {
                body += character;
            }
            else if (comment === false && wasComment === false) {
                selector += character;
            }
        }
    };
}

var GlitzClient =  (function () {
    function GlitzClient(options) {
        if (options === void 0) { options = {}; }
        var _a;
        var prefix = options.prefix;
        var classNameHash = createHashCounter(prefix);
        var keyframesHash = createHashCounter(prefix);
        var mediaOrderOption = options.mediaOrder;
        var mediaSheets = {};
        var initialMediaSheet = null;
        var plain;
        var mediaInjectors = {};
        var identifier = (_a = options.identifier) !== null && _a !== void 0 ? _a : DEFAULT_HYDRATION_IDENTIFIER;
        var getInjector = function (media) {
            if (media) {
                if (mediaInjectors[media]) {
                    return mediaInjectors[media];
                }
                var element = (mediaSheets[media] = createStyleElement(media, identifier));
                var insertBefore = null;
                if (mediaOrderOption) {
                    var orderedMediaKeys = Object.keys(mediaSheets).sort(mediaOrderOption);
                    initialMediaSheet = mediaSheets[orderedMediaKeys[0]];
                    insertBefore = mediaSheets[orderedMediaKeys[orderedMediaKeys.indexOf(media) + 1]] || null;
                }
                insertStyleElement(element, insertBefore);
                return (mediaInjectors[media] = new InjectorClient(element, classNameHash, keyframesHash));
            }
            else {
                if (plain) {
                    return plain;
                }
                var element = insertStyleElement(createStyleElement(media, identifier), initialMediaSheet);
                return (plain = new InjectorClient(element, classNameHash, keyframesHash));
            }
        };
        var _b = createStyleInjectors(getInjector, options.transformer), injectStyle = _b[0], injectGlobals = _b[1];
        this.injectStyle = injectStyle;
        this.injectGlobals = injectGlobals;
        var hydrate = (this.hydrate = createHydrate(getInjector));
        var preRenderedStyleElements = document.head.querySelectorAll("style[data-".concat(identifier, "]"));
        if (preRenderedStyleElements) {
            for (var _i = 0, preRenderedStyleElements_1 = preRenderedStyleElements; _i < preRenderedStyleElements_1.length; _i++) {
                var element = preRenderedStyleElements_1[_i];
                var media = element.media;
                if (media) {
                    if (!initialMediaSheet) {
                        initialMediaSheet = element;
                    }
                    mediaSheets[media] = element;
                    mediaInjectors[media] = new InjectorClient(element, classNameHash, keyframesHash);
                }
                else {
                    plain = new InjectorClient(element, classNameHash, keyframesHash);
                }
                hydrate(element.textContent, media);
            }
            if (process.env.NODE_ENV !== 'production') {
                if (mediaOrderOption) {
                    var medias = Object.keys(mediaSheets);
                    var orderedMedias = medias.sort(mediaOrderOption);
                    for (var index in medias) {
                        if (medias[index] !== orderedMedias[index]) {
                            console.warn('The order of media queries rendered by the server did not meet the expected ' +
                                'order by the browser. Make sure you pass the same function to the `mediaOrder`' +
                                'option for both `GlitzServer` and `GlitzClient`.');
                            break;
                        }
                    }
                }
            }
        }
        var streamedStyleElements = document.body.querySelectorAll("style[data-".concat(identifier, "]"));
        if (streamedStyleElements) {
            for (var _c = 0, streamedStyleElements_1 = streamedStyleElements; _c < streamedStyleElements_1.length; _c++) {
                var element = streamedStyleElements_1[_c];
                hydrate(element.textContent, element.media, function (injector, rule) { return injector.injectRaw(rule); });
                element.parentNode.removeChild(element);
            }
        }
    }
    return GlitzClient;
}());

var InjectorServer =  (function (_super) {
    __extends(InjectorServer, _super);
    function InjectorServer(classNameHash, keyframesHash, postInjection, fullIndexes, hydrationIndex) {
        if (postInjection === void 0) { postInjection = false; }
        if (fullIndexes === void 0) { fullIndexes = createInjectorIndexes(); }
        if (hydrationIndex === void 0) { hydrationIndex = createInjectorIndexes(); }
        var _this = this;
        var getFullIndex = fullIndexes[0], keyframesFullIndex = fullIndexes[1], fontFaceFullIndex = fullIndexes[2], cloneFullIndex = fullIndexes[3];
        var getHydrationIndex = hydrationIndex[0], keyframesHydrationIndex = hydrationIndex[1], fontFaceHydrationIndex = hydrationIndex[2], cloneHydrationIndex = hydrationIndex[3];
        var _a = createInjectorIndexes(), getResultIndex = _a[0], keyframesResultIndex = _a[1], fontFaceResultIndex = _a[2]; _a[3]; var plainResultIndex = _a[4], plainSupportsResultIndex = _a[5], selectorResultIndex = _a[6], selectorSupportsResultIndex = _a[7];
        var _c = createInjectorIndexes(), getStreamIndex = _c[0], keyframesStreamIndex = _c[1], fontFaceStreamIndex = _c[2]; _c[3]; var plainStreamIndex = _c[4], plainSupportsStreamIndex = _c[5], selectorStreamIndex = _c[6], selectorSupportsStreamIndex = _c[7];
        var globalsResult = '';
        var globalsStream = '';
        _this = _super.call(this, function (block, selector, condition) {
            postInjection = true;
            var full = getFullIndex(selector, condition);
            if (full[block]) {
                return full[block];
            }
            var className = classNameHash();
            var result = getResultIndex(selector, condition);
            var stream = getStreamIndex(selector, condition);
            full[block] = result[block] = stream[block] = className;
            return className;
        }, function (blockList) {
            postInjection = true;
            if (keyframesFullIndex[blockList]) {
                return keyframesFullIndex[blockList];
            }
            var name = keyframesHash();
            keyframesFullIndex[blockList] = keyframesResultIndex[blockList] = keyframesStreamIndex[blockList] = name;
            return name;
        }, function (block) {
            postInjection = true;
            if (fontFaceFullIndex.indexOf(block) === -1) {
                fontFaceFullIndex.push(block);
                fontFaceResultIndex.push(block);
                fontFaceStreamIndex.push(block);
            }
        }, function (rule) {
            globalsResult += rule;
            globalsStream += rule;
        }) || this;
        _this.getStyle = function (stream) {
            var _a, _b;
            if (stream === void 0) { stream = false; }
            var result = '';
            if (stream) {
                result += globalsStream;
                globalsStream = '';
            }
            else {
                result += globalsResult;
            }
            var fontFaces = stream ? fontFaceStreamIndex : fontFaceResultIndex;
            for (var _i = 0, fontFaces_1 = fontFaces; _i < fontFaces_1.length; _i++) {
                var block = fontFaces_1[_i];
                result += formatFontFaceRule(block);
            }
            if (stream) {
                fontFaceStreamIndex.length = 0;
            }
            var keyframes = stream ? keyframesStreamIndex : keyframesResultIndex;
            for (var blockList in keyframes) {
                result += formatKeyframesRule(keyframes[blockList], blockList);
                if (stream) {
                    delete keyframesStreamIndex[blockList];
                }
            }
            var plains = stream ? plainStreamIndex : plainResultIndex;
            for (var block in plains) {
                result += formatClassRule(plains[block], block);
                if (stream) {
                    delete plainStreamIndex[block];
                }
            }
            var supportsBlocks = {};
            var plainSupports = stream ? plainSupportsStreamIndex : plainSupportsResultIndex;
            for (var condition in plainSupports) {
                for (var block in plainSupports[condition]) {
                    (_a = supportsBlocks[condition]) !== null && _a !== void 0 ? _a : (supportsBlocks[condition] = '');
                    supportsBlocks[condition] += formatClassRule(plainSupports[condition][block], block);
                }
                if (stream) {
                    delete plainSupportsStreamIndex[condition];
                }
            }
            var selectors = stream ? selectorStreamIndex : selectorResultIndex;
            for (var selector in selectors) {
                var index = selectors[selector];
                for (var block in index) {
                    result += formatClassRule(index[block], block, selector);
                }
                if (stream) {
                    delete selectorStreamIndex[selector];
                }
            }
            var selectorSupports = stream ? selectorSupportsStreamIndex : selectorSupportsResultIndex;
            for (var condition in selectorSupports) {
                for (var selector in selectorSupports[condition]) {
                    var index = selectorSupports[condition][selector];
                    for (var block in index) {
                        (_b = supportsBlocks[condition]) !== null && _b !== void 0 ? _b : (supportsBlocks[condition] = '');
                        supportsBlocks[condition] += formatClassRule(index[block], block, selector);
                    }
                }
                if (stream) {
                    delete selectorSupportsStreamIndex[condition];
                }
            }
            for (var condition in supportsBlocks) {
                result += formatSupportsRule(condition, supportsBlocks[condition]);
            }
            return result;
        };
        function createPreActionCheck(action) {
            return function () {
                if (postInjection) {
                    throw new Error("".concat(action, " is prohibited after injections"));
                }
            };
        }
        var preHydrationCheck = createPreActionCheck('Hydration');
        _this.hydrateClassName = function (body, className, selector, condition) {
            preHydrationCheck();
            classNameHash();
            var full = getFullIndex(selector, condition);
            var hydration = getHydrationIndex(selector, condition);
            full[body] = hydration[body] = className;
        };
        _this.hydrateKeyframes = function (body, name) {
            preHydrationCheck();
            keyframesHash();
            keyframesFullIndex[body] = name;
            keyframesHydrationIndex[body] = name;
        };
        _this.hydrateFontFace = function (rule) {
            preHydrationCheck();
            fontFaceFullIndex.push(rule);
            fontFaceHydrationIndex.push(rule);
        };
        var preCloningCheck = createPreActionCheck('Cloning');
        _this.clone = function (classNameHashClone, keyframesHashClone) {
            preCloningCheck();
            return new InjectorServer(classNameHashClone, keyframesHashClone, postInjection, cloneFullIndex(), cloneHydrationIndex());
        };
        return _this;
    }
    return InjectorServer;
}(Injector));

var GlitzServer =  (function () {
    function GlitzServer(options, classNameHash, keyframesHash, plainInjector, mediaInjectors) {
        if (options === void 0) { options = {}; }
        if (classNameHash === void 0) { classNameHash = createHashCounter(options.prefix); }
        if (keyframesHash === void 0) { keyframesHash = createHashCounter(options.prefix); }
        if (mediaInjectors === void 0) { mediaInjectors = {}; }
        var _a;
        this.diagnostics = [];
        var identifier = (this.identifier = (_a = options.identifier) !== null && _a !== void 0 ? _a : DEFAULT_HYDRATION_IDENTIFIER);
        var getInjector = function (media) {
            var _a;
            return media
                ? ((_a = mediaInjectors[media]) !== null && _a !== void 0 ? _a : (mediaInjectors[media] = new InjectorServer(classNameHash, keyframesHash)))
                : (plainInjector !== null && plainInjector !== void 0 ? plainInjector : (plainInjector = new InjectorServer(classNameHash, keyframesHash)));
        };
        var _b = createStyleInjectors(getInjector, options.transformer), injectStyle = _b[0], injectGlobals = _b[1];
        this.injectStyle = injectStyle;
        this.injectGlobals = injectGlobals;
        this.hydrate = createHydrate(getInjector);
        this.getStyle = function (markup, stream) {
            if (markup === void 0) { markup = false; }
            if (stream === void 0) { stream = false; }
            var result = '';
            if (plainInjector) {
                var style = plainInjector.getStyle(stream);
                result += markup ? "<style data-".concat(identifier, ">").concat(style, "</style>") : style;
            }
            var queries = Object.keys(mediaInjectors);
            if (options.mediaOrder) {
                queries = queries.sort(options.mediaOrder);
            }
            for (var _i = 0, queries_1 = queries; _i < queries_1.length; _i++) {
                var query = queries_1[_i];
                var style = mediaInjectors[query].getStyle(stream);
                if (style) {
                    result += markup
                        ? "<style data-".concat(identifier, " media=\"").concat(query, "\">").concat(style, "</style>")
                        : formatMediaRule(query, style);
                }
            }
            return result;
        };
        this.clone = function () {
            var classNameHashClone = classNameHash.clone();
            var keyframesHashClone = keyframesHash.clone();
            var mediaInjectorsClone = {};
            for (var media in mediaInjectors) {
                mediaInjectorsClone[media] = mediaInjectors[media].clone(classNameHashClone, keyframesHashClone);
            }
            return new GlitzServer(options, classNameHashClone, keyframesHashClone, plainInjector === null || plainInjector === void 0 ? void 0 : plainInjector.clone(classNameHashClone, keyframesHashClone), mediaInjectorsClone);
        };
    }
    return GlitzServer;
}());

function media(list, style) {
    var _a;
    return _a = {}, _a["@media ".concat(typeof list === 'string' ? list : query(list))] = style, _a;
}
function query(list) {
    var result = '';
    var feature;
    for (feature in list) {
        if (result) {
            result += ' and ';
        }
        var value = list[feature];
        result += value === true ? "(".concat(hyphenateProperty(feature), ")") : "(".concat(hyphenateProperty(feature), ": ").concat(value, ")");
    }
    return result;
}

function selector(selectors, style) {
    var _a;
    return typeof selectors === 'string'
        ? (_a = {}, _a[selectors] = style, _a) : selectors.reduce(function (acc, value) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[value] = style, _a)));
    }, {});
}

function compose() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return fns.reduceRight(function (prevFn, nextFn) { return function (arg) { return nextFn(prevFn(arg)); }; });
}

export { GlitzClient, GlitzServer, compose, media, query, selector };
